import styled from 'styled-components';
import { Button, ButtonColor } from '../../../ui/button/Button';

// tslint:disable-next-line:variable-name
const AgreeButton = styled(Button)(
  ({ theme, disabled }) => `
  width: 100%;
  background-color: ${disabled ? theme.colors.disabledButton : theme.colors.primaryLightBlue};
  @media only screen and ${theme.device.laptopS} {
    width: 255px;
  }
`
);

export default AgreeButton;
